import React, { useMemo } from "react";
import styled from "@emotion/styled";
import get from "lodash.get";
import { useIntl } from "react-intl";

import CommonUtils from "services/common/utils";
import ContractUtils from "services/contract/utils";
import VisitorCharacteristicsUtils from "services/visitorCharacteristics/utils";

import StatsChart from "components/StatsChart";
import Section from "components/Section";
import ToggleButtonGroup from "components/ToggleButtonGroup";
import { GraphProvider } from "../../../../services/graphs";

const ToggleButtonGroupContainer = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 10px;
`;
function QualitificationTimeSection({
  averageTimeMaximumDuration,
  visitorCharacteristics,
  setQualificationTimeFilters,
  contract,
}) {
  const intl = useIntl();
  const timeChartTooltip = useMemo(() => {
    if (!averageTimeMaximumDuration) {
      return null;
    }

    return intl.formatMessage(
      {
        id: "visitorCharacteristicsScene.sections.qualificationTime.infoTooltip",
      },
      {
        duration: CommonUtils.humanizeDateFromDuration(
          averageTimeMaximumDuration,
          "minutes",
          intl,
          false
        ),
      }
    );
  }, [intl, averageTimeMaximumDuration]);

  const qualificationTimeCharts =
    VisitorCharacteristicsUtils.getQualificationTimeChart(
      get(visitorCharacteristics, "qualificationTime"),
      intl
    );

  const options = new Array(7).fill(0).map((item, index) => ({
    label: intl.messages[`daysOfWeek.${index}`],
    value: index + 1,
  }));
  const selectedDays =
    get(visitorCharacteristics, "qualificationTime.filters.dow") &&
    Array.isArray(get(visitorCharacteristics, "qualificationTime.filters.dow"))
      ? get(visitorCharacteristics, "qualificationTime.filters.dow")
      : [get(visitorCharacteristics, "qualificationTime.filters.dow")];

  const selectedAreaLabel = visitorCharacteristics?.filters?.areas?.find(
    (area) => area.id === visitorCharacteristics?.filters?.selectedArea
  )?.long_name;

  return (
    qualificationTimeCharts && (
      <GraphProvider
        timeTitle={`[${ContractUtils.formatTimestamp(
          contract,
          visitorCharacteristics?.filters?.from
        )}]-[${ContractUtils.formatTimestamp(
          contract,
          visitorCharacteristics?.filters?.to
        )}]`}
        label={selectedAreaLabel}
      >
        <Section
          title={
            intl.messages[
              "visitorCharacteristicsScene.sections.qualificationTime.title"
            ]
          }
          infoTooltip={timeChartTooltip}
        >
          <ToggleButtonGroupContainer>
            <ToggleButtonGroup
              loading={!visitorCharacteristics.qualificationTime.initialized}
              options={options}
              value={selectedDays || []}
              onChange={(e, value) => {
                if (
                  value === null ||
                  (Array.isArray(value) && value.length === 0)
                ) {
                  return null;
                }
                return setQualificationTimeFilters({ dow: value });
              }}
            />
          </ToggleButtonGroupContainer>

          <StatsChart
            initialized={visitorCharacteristics?.qualificationTime?.initialized}
            stats={qualificationTimeCharts?.data}
            graphOptions={qualificationTimeCharts?.options}
            height="330px"
          />
        </Section>
      </GraphProvider>
    )
  );
}

export default QualitificationTimeSection;
